import { ColumnDef } from "@tanstack/react-table";
import { EditIcon, TrashAltIcon } from "assets/icons";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import moment from "moment";
import { useMemo, useState } from "react";
import { ItemsTable, TableItemActionsControl } from "ui";

import { IWarehouse } from "../../warehouses.types";
import { WarehousesTableProps } from "./WarehousesTable.types";

const WarehousesTable = ({
  warehouses,
  isLoading,
  sorting,
  setSorting,
  onEdit,
  onDelete,
}: WarehousesTableProps) => {
  const [openedItemOptionsIndex, setOpenedItemOptionsIndex] = useState<
    number | null
  >(null);

  const columns: Array<ColumnDef<IWarehouse>> = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Name"),
        size: 50,
        minSize: 50,
        cell: ({ row }) => (
          <span style={{ fontWeight: 700 }}>{row.original.name}</span>
        ),
      },
      {
        id: "isReturnPickupPoint",
        accessorKey: "isReturnPickupPoint",
        header: t("Return pickup"),
        size: 30,
        minSize: 30,
        cell: ({ row }) =>
          row.original.isReturnPickupPoint ? t("Yes") : "—",
      },
      {
        id: "createdAt",
        accessorKey: "createdAt",
        header: t("Created"),
        size: 40,
        minSize: 40,
        cell: ({ row }) =>
          moment(row.original.createdAt).format("DD MMM YYYY, HH:mm"),
      },
      {
        accessorKey: "dotsColumn",
        header: () => null,
        size: 6,
        minSize: 6,
        enableSorting: false,
        cell: ({ row }) => (
          <TableItemActionsControl
            actionsList={[
              {
                label: "Edit",
                Icon: <EditIcon fill="#090914" width={18} height={18} />,
                onClick: () => onEdit(row.original),
              },
              {
                label: "Delete",
                Icon: <TrashAltIcon fill="#ff0033" width={18} height={18} />,
                labelColor: "#ff0033",
                onClick: () => onDelete(row.original),
              },
            ]}
            rowIndex={row.index}
            setOpenedItemOptionsIndex={setOpenedItemOptionsIndex}
            openedItemOptionsIndex={openedItemOptionsIndex}
          />
        ),
      },
    ],
    [warehouses, openedItemOptionsIndex],
  );

  return (
    <ItemsTable
      columns={columns}
      data={warehouses}
      sorting={sorting}
      setSorting={setSorting}
      isLoading={isLoading}
      skeletonHeight={56}
      emptyListMessage="No warehouses yet"
    />
  );
};

export default WarehousesTable;
